export const getCoordinatesByAddress = async (address) => {
  const location = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address.street1}%20${address.street2}%20${address.postcode}%20${address.city}&key=AIzaSyACCs5y681MayfxRymmNO7wrWjDCGFvvQA`
  ).then((res) => res.json());

  console.log('Location fetched:', location);
  const latitude = location.results[0]?.geometry.location.lat + '';
  const longitude = location.results[0]?.geometry.location.lng + '';

  return { latitude, longitude };
};
